import angular from "angular"
import authorizationModule from "./authorizationModule"
import arrays from "../../bower_components/front-end-web-commons/app/arrays/arrays"
import menuItems from "../menu/menuItems"

const ABSTRACT_SEARCH_GROUPS_BY_HREF = new Map()

const SEARCH_GROUP = "r2.search"
const CADASTRE_GROUP = "group.r2.cadastre"
authorizationModule.service("authorizationService", function (permissionService, dynamicMenuItemsService, $state) {


    this.getAuthorizedMenus = () => {
        return permissionService.getAuthorization()
            .then((authorization) => {
                let authorizedMenus = authorizeMenus(authorization, angular.copy(menuItems))
                dynamicMenuItemsService.setMenuItems(authorizedMenus)
                return authorizedMenus
            })
    }

    function authorizeMenus(authorization, menuItems) {
        if (!menuItems) {
            return []
        }
        return arrays.filter(menuItems, function (menu) {
            menu.subMenus = authorizeMenus(authorization, menu.subMenus)
            return authorization(menu.groupName).canRead
        })
    }


    this.getAbstractSearchGroupOrCadastre = (stateParams) => {
        return ABSTRACT_SEARCH_GROUPS_BY_HREF.get($state.href(SEARCH_GROUP, stateParams || {})) || CADASTRE_GROUP
    }

    setGroupsByHref(menuItems)

    function setGroupsByHref(userMenu) {
        userMenu.forEach(function (menuItem) {
            return menuItem.subMenus.forEach(function (menuItem) {
                if (isAbstractSearchState(menuItem)) {
                    ABSTRACT_SEARCH_GROUPS_BY_HREF.set(getHref(menuItem), menuItem.groupName)
                }
                if (hasSubMenus(menuItem)) {
                    setSubStateGroups(menuItem.subMenus, ABSTRACT_SEARCH_GROUPS_BY_HREF)
                }
            })
        })
        return ABSTRACT_SEARCH_GROUPS_BY_HREF
    }

    function isAbstractSearchState(menuItem) {
        return !!menuItem.state && menuItem.state === SEARCH_GROUP
    }

    function getHref(menuItem) {
        return $state.href(menuItem.state, menuItem.stateParams || {})
    }

    function hasSubMenus(menuItem) {
        return menuItem.subMenus && menuItem.subMenus.length
    }

    function setSubStateGroups(menuItem, HREF_BY_GROUPS) {
        return menuItem.forEach(function (menuItem) {
            if (isAbstractSearchState(menuItem)) {
                HREF_BY_GROUPS.set(getHref(menuItem), menuItem.groupName)
            }
            if (hasSubMenus(menuItem)) {
                setSubStateGroups(menuItem.subMenus, HREF_BY_GROUPS)
            }
        })
    }
})
